var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouseClic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.6 37.3",
    style: {
      enableBackground: "new 0 0 27.6 37.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st1{fill:#DD4040;}\n\t.st2{fill:none;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:1.0003;stroke-miterlimit:4.001;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3494",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 16694.828, 17718.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1884",
    className: "st0",
    d: "M-13344.3-20344.3L-13344.3-20344.3c6.1,0,11,4.9,11,11v12c0,6.1-4.9,11-11,11l0,0 c-6.1,0-11-4.9-11-11v-12C-13355.3-20339.4-13350.3-20344.3-13344.3-20344.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1886",
    className: "st1",
    d: "M-13345.3-20344.3h1l0,0v15l0,0h-11l0,0v-5 C-13355.3-20339.8-13350.8-20344.3-13345.3-20344.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3492",
    transform: "translate(73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1884-2",
    transform: "translate(-13438 -20345)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.7,0.7l2,0c5.5,0,10,4.5,10,10v14c0,5.5-4.5,10-10,10h-2c-5.5,0-10-4.5-10-10l0-14 C9.7,5.2,14.2,0.7,19.7,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.7,1.2h2c5.2,0,9.5,4.3,9.5,9.5v14c0,5.2-4.3,9.5-9.5,9.5h-2c-5.2,0-9.5-4.3-9.5-9.5l0-14 C10.2,5.5,14.5,1.2,19.7,1.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1887",
    className: "st2",
    d: "M-13417.3-20337.3L-13417.3-20337.3c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2l0,0 c-1.1,0-2-0.9-2-2v-4C-13419.3-20336.4-13418.4-20337.3-13417.3-20337.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1888",
    className: "st4",
    d: "M-13344.3-20337.3L-13344.3-20337.3c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2l0,0 c-1.1,0-2-0.9-2-2v-4C-13346.3-20336.4-13345.4-20337.3-13344.3-20337.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseClic);
export default __webpack_public_path__ + "static/media/Mouse_clic.51ce9c8fabcfd4b7710ca43352ee8a11.svg";
export { ForwardRef as ReactComponent };